// import images
import drugomicsLogo from "../../image/Logo_drug.svg";
import labImage from "../../image/drugomics/drugomics.jpg";
import dnaImage from "../../image/drugomics/dna-robot-hand.jpg";
import womenLabImage from "../../image/drugomics/women-lab-coat.jpeg";
import drugBanner from "../../image/drugomics/busy-chef-preparing.jpg";
import drugSecImage from "../../image/drugomics/biomedical-engineer.jpg";
import vaccineBanner from "../../image/drugomics/portrait-women-lab.jpg";
import vaccineSecImage from "../../image/drugomics/focused-female-scientist.jpg"
import medicineBanner from "../../image/drugomics/doctor-from-future.jpg";
import medicineSecImage from "../../image/drugomics/male-pharmacist.jpg";
import pipelineBanner from "../../image/drugomics/biomedical-student-working.jpg"
import partnerImage from "../../image/drugomics/partnership.svg";
import bannervideo from "../../image/drugomics/Drugomics banner video-small.mp4";

// import data
import contentData from "../../data/content/drugomics/drugomicsContent.json";
import servicesData from "../../data/content/drugomics/drugServices.json";
import unitContentData from "../../data/content/drugomics/drugServicesContent.json";
import pipelineContentData from "../../data/content/drugomics/drugPipelineContent.json";

import { DataKeys, DataStructure } from '../../types';
// import components
import { MainFrame, HorizontalScrollArrowsFrame, HorizontalScrollWithTopRightArrows, Col2ContentFrame, ColAutoFrame, SpacingFrame, Col3ContentFrame, Col4ContentFrame } from "../display/Frame";
import { MemberCard, StepsCard, LeftBorderCard, StepsCardWithList, StepsCard3 } from "../display/Cards";
import { BannerSection, MainIdeaSection, BusinessBannerSection, StatsSection,ImpactStatsCard, Section3Card, BannerVideoSection} from "../display/Sections";
import { ImageBanner } from "../display/ImageFormat";
import { TitleSubtitle, CapsText, TextBody } from "../display/TextFormat";
import { MoreButton } from "../tools/Buttons";
import { NavTree } from "../navigation/NavLinkPages";
import { UpdateSummary } from "../content/BlogNews";
import DrugPipeline, { DrugDesignSection, OtherDrugServicesCard } from "../content/DrugContent";
import { NumberCounterAnim } from "../tools/Animations";
import { AtomToolsOverview } from "../content/ToolsOverview";
import { SlideInAnim } from "../tools/Animations";
import { ContactUsButton } from "../tools/Buttons";
// import function
import { filterPeopleData } from "../../functions/DataFunctions";
import { useDocumentTitle } from "../../functions/useDocumentTitle";
import { DisplayInfo2Cols,ImageTextWithCards } from "../../functions/DisplayInfoFunctions";
// import context
import { useScreenSize, useLang } from "../Context";
// import global var
import { typedVocab } from "../GlobalVar";
import { AboutDefaultBanner } from "./About/About";

// import icons
import { Rocket } from "lucide-react";
import { Send, ArrowLeft, ArrowRight } from "lucide-react";
import navUnitsData from "../../data/navUnits.json";
const typedNavUnitsData : DataStructure = navUnitsData;

const typedContent : DataStructure = contentData;
const typedServices : DataStructure = servicesData;
const typedUnitContent : DataStructure = unitContentData;
const typePipelineContent : DataStructure = pipelineContentData;
const imagePath = "image/drugomics/";

const DRUGOMICS_BRAND_KEY = "Graphen Drugomics";

/** Browser tabs truncate quickly; JP brand strings are very long — use English for Jp locale. */
function drugomicsDocumentTitleLang(lang: string): string {
    return lang === "Jp" ? "En" : lang;
}

function drugomicsBrandTitle(lang: string): string {
    const titleLang = drugomicsDocumentTitleLang(lang);
    return typedVocab[DRUGOMICS_BRAND_KEY][titleLang];
}

function drugomicsChildTitle(pageTitle: string, lang: string): string {
    return `${pageTitle} | ${drugomicsBrandTitle(lang)}`;
}

function drugomicsServiceTitle(serviceKey: string, lang: string): string {
    const titleLang = drugomicsDocumentTitleLang(lang);
    return typedServices[serviceKey]["title"][titleLang];
}

function drugomicsLocalizedTitle(
    localized: DataKeys,
    lang: string
): string {
    const titleLang = drugomicsDocumentTitleLang(lang);
    return localized[titleLang] as string;
}

export default function Drugnomics() {
    const { screenSize } = useScreenSize();
    const { lang } = useLang();

    useDocumentTitle(drugomicsBrandTitle(lang));

    // extract section data
    const section1 = typedContent[1];
    const section2 = typedContent[2];
    const section3 = typedContent[3];
    const section4 = typedContent[4];
    const section5 = typedContent[5];
    const section7 = typedContent[7];
    const section6 = typedContent[6];
    const section8 = typedContent[8];
    const section9 = typedContent[9];
    const section10 = typedContent[10];

    // section 3: 
    let drugContent = Object.keys(section3["content"]).map((i) => {
        let data = section3["content"][i];
        return (
            <div className="flex flex-col gap-2">
                <p className="text-left text-2xl font-bold text-grey-900">
                    <NumberCounterAnim value={ data["number"] } />
                    <span>{ data["title"][lang] }</span>
                </p>
                <p className="text-left text-sm font-semibold text-grey-500">{ data["subtitle"][lang] }</p>
                <p className="text-left text-sm text-grey-400">{ data["text"][lang] }</p>
            </div>
        )
    });

    // section 5: people
    const peopleData = filterPeopleData(section5["people"]) as DataStructure;
    let membershipCards = Object.keys(peopleData).map((i) => {
        let data = peopleData[i] as DataKeys;
        return (
            <MemberCard data={data} />
        )
    });


    return (
        <>
            {/* <BusinessBannerSection 
                bgImage={ labImage }
                logoImage={ drugomicsLogo }
                title={ section1["title"][lang] }
                subtitle={ section1["subtitle"][lang] }
            /> */}

            <BannerVideoSection
            videoSrc={bannervideo}
            title={ section1["title"][lang] }
            subtitle={ section1["subtitle"][lang] }
            buttonLabel={typedVocab["Partner with Us1"][lang]}
            buttonLink={`mailto:${typedNavUnitsData["Company_Email"][lang]}`}
            darkMode
            />
            
            <NavTree />

            {/* <MainFrame style={{ backgroundColor: "rgba(162, 218, 219, 0.4)" }}>
                <CapsText text={ section2["capsText"][lang] } />
                <TitleSubtitle title={ section2["title"][lang] } />
                <DrugDesignSection />
            </MainFrame> */}

            <MainFrame smallerPadding>
                <div
                    style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}
                    className="rounded-3xl">
                    <ImpactStatsCard title={ section7["title"][lang] } subtitle={ section7["subtitle"][lang] } data={ section7["content"] } />
                </div>
            </MainFrame>

            {/* <DisplayInfo2Cols contentData={section6} imagePath={imagePath} /> */}
            <ImageTextWithCards contentData={section6} imagePath={imagePath} smallerPadding/>

            <DisplayInfo2Cols contentData={section8} imagePath={imagePath} smallerPadding/>

    
            <MainFrame smallerPadding>
                <div style={{ backgroundColor: "rgba(248, 249, 250, 1)" }} className="rounded-3xl">
                    <Section3Card 
                    title={section3["title"][lang]} subtitle={section3["subtitle"]?.[lang]} capsText={section3["capsText"][lang]} data={section3["content"]} icon={section3["icon"]} />
                </div>
            </MainFrame>


            {/* <MainFrame>
                <SpacingFrame>
                    <div>
                        <CapsText text={ section3["capsText"][lang] } style="text-left text-grey-400" />
                        <TitleSubtitle title={ section3["title"][lang] } left />
                    </div>
                    <Col2ContentFrame>
                        <SlideInAnim direction="left">
                            <div className="flex items-center justify-center">
                                <img src={dnaImage} />
                            </div>
                        </SlideInAnim>
                        <div className="grid grid-flow-row auto-rows-min gap-6 text-base">
                            { drugContent }
                        </div>
                    </Col2ContentFrame>
                </SpacingFrame>
            </MainFrame> */}
            <AtomToolsOverview isMoreButton smallerPadding />

            <MainFrame smallerPadding>
                <SpacingFrame spacing={40}>
                    <DrugPipeline />
                    {/* <div className="flex items-center justify-center">
                        <MoreButton label="View Full Pipeline" link="/drugomics/drug-design/pipeline" />
                    </div> */}
                </SpacingFrame>
            </MainFrame>

            {/* <ImageBanner image={womenLabImage} /> */}

            {/* <DisplayInfo2Cols contentData={ section4["content"] } imagePath={imagePath} title={ section4["title"][lang] } /> */}
            

            <MainFrame smallerPadding>
                <SpacingFrame>
                    <TitleSubtitle 
                        title={ section5["title"][lang] } left
                    />
                    <div>
                        <HorizontalScrollWithTopRightArrows>
                            { membershipCards }
                        </HorizontalScrollWithTopRightArrows>
                    
                        <div style={{ margin: "30px 0" }}></div>
                        { (screenSize === "Large" || screenSize === "Small") && (
                             <MoreButton label="View All Members" link="/about/team" />
                        )}
                    </div>
                </SpacingFrame>
            </MainFrame>
            

            <MainFrame pt={64} pb={128}>
            <div
                className="rounded-3xl"
                style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}
            >
                <div className="flex flex-col gap-16 lg:gap-8 px-6 lg:px-12 py-12">
               
                <div className="flex flex-col lg:flex-row justify-between items-center gap-8">
                  
                    <div className="w-full lg:w-1/2 flex flex-col gap-6">
                    <div className="flex items-center gap-2">
                        <Rocket className="w-10 h-10 lg:w-5 lg:h-5 my-auto" />
                        <p className="text-left text-[20px] text-grey-800">{section10["Join Us 1"][lang]}</p>
                    </div>

                    <p className="text-left text-[32px] font-semibold text-grey-900 whitespace-pre-line">
                        {section10["Join Us 2"][lang]}
                    </p>
                    <p className="text-left text-sm font-light">
                        {section10["Join Us 3"][lang]}
                    </p>
                    </div>

                  
                    <div className="w-full lg:w-1/2 flex justify-center">
                    <img src={partnerImage} alt="" />
                    </div>
                </div>

              
                <div className="flex justify-center lg:justify-start">
                    <button className="group w-fit rounded-3xl px-10 py-1 border-2 border-grey-500 text-white bg-grey-500 hover:text-teal-300">
                                <a className="flex items-center justify-center gap-2" href={`mailto:${typedNavUnitsData["Company_Email"][lang]}`}>
                                    <p className="text-white group-hover:text-teal-300">{ typedVocab["Partner with Us"][lang] }</p>
                                    <Send size={16} />
                                </a>
                    </button>
                    </div>
                </div>
            </div>
            </MainFrame>


            {/* <UpdateSummary /> */}
        </>
    )
};


//////////////////////
// LOCAL FUNCTIONS //
/////////////////////
interface ExploreOtherServicesProps {
    location: string;
};
function ExploreOtherServices({ location } : ExploreOtherServicesProps) {
    const { lang } = useLang();

    let content = Object.keys(typedServices).map((i) => {
        let data = typedServices[i];
        data["key"] = i;
        if (i !== location) {
            return (
                <OtherDrugServicesCard data={data} />
            )
        };
    })
    return (
        <MainFrame style={{ backgroundColor: "rgba(162, 218, 219, 0.4)" }}>
            <SpacingFrame>
                <TitleSubtitle title={ typedVocab["Explore More Drugomics"][lang] } />
                <ColAutoFrame>
                    { content }
                </ColAutoFrame>
            </SpacingFrame>
        </MainFrame>
    )
};

//////////////////////////
// OTHER SERVICES PAGE //
/////////////////////////
export function DrugDesign() {
    const { lang } = useLang();

    const data = typedUnitContent["Drug Design"];
    const section1 = data[1];
    useDocumentTitle(
        drugomicsChildTitle(drugomicsServiceTitle("drug-design", lang), lang)
    );
    const section2 = data[2];
    const section3 = data[3];
    const section4 = data[4];

    // section 4: drug dev steps
    let devSteps = Object.keys(section4["content"]).map((i) => {
        let content = section4["content"][i];
        return (
            <StepsCard data={content} />
        )
    });
    
    return (
        <>
            <BannerSection image={pipelineBanner} title={ section1["title"][lang] } subtitle={ section1["caption"][lang] } textPosition="Top" />

            <NavTree />

            <MainIdeaSection text={ section2["text"][lang] } />

            <MainFrame>
                <StatsSection title={ section3["title"][lang] } subtitle={ section3["subtitle"][lang] } data={ section3["content"] } />
            </MainFrame>

            <MainFrame>
                <SpacingFrame spacing={40}>
                    <TitleSubtitle title={ section4["title"][lang] } />
                    <p>{ section4["subtitle"][lang] }</p>
                    <SlideInAnim direction="bottom">
                        <img className="p-6" src={require("../../image/drugomics/" + section4["image"])} />
                    </SlideInAnim>
                    <ColAutoFrame>
                        { devSteps }
                    </ColAutoFrame>
                </SpacingFrame>
            </MainFrame>

            <ImageBanner image={drugSecImage} />

            <MainFrame>
                <SpacingFrame spacing={40}>
                    <DrugPipeline />
                    <div className="flex items-center justify-center">
                        <MoreButton label="View Full Pipeline" link="/drugomics/drug-design/pipeline" />
                    </div>
                </SpacingFrame>
            </MainFrame>

            <ExploreOtherServices location="drug-design" />
        </>
    )
};

export function VaccineDesign() {
    const { lang } = useLang();

    const data = typedUnitContent["Vaccine Design"];
    const section1 = data[1];
    useDocumentTitle(
        drugomicsChildTitle(drugomicsServiceTitle("vaccine-design", lang), lang)
    );
    const section2 = data[2];
    const section3 = data[3];
    const section4 = data[4];

    // section 3: steps
    let devSteps = Object.keys(section3["content"]).map((i) => {
        let content = section3["content"][i];
        return (
            <StepsCard data={content} />
        )
    });

    // section 4: advantages
    let advantages = Object.keys(section4["content"]).map((i) => {
        let content = section4["content"][i];
        return (
            <LeftBorderCard data={content} />
        )
    });

    return (
        <>
            <BannerSection image={vaccineBanner} title={ section1["title"][lang] } subtitle={ section1["caption"][lang] } textPosition="Top" />

            <NavTree />

            <MainIdeaSection text={ section2["text"][lang] } />

            <MainFrame>
                <SpacingFrame spacing={40}>
                    <TitleSubtitle title={ section3["title"][lang] } />
                    <p>{ section3["subtitle"][lang] }</p>
                    <SlideInAnim direction="bottom">
                        <img className="p-6" src={require("../../image/drugomics/" + section3["image"])} />
                    </SlideInAnim>
                    <ColAutoFrame>
                        { devSteps }
                    </ColAutoFrame>
                </SpacingFrame>
            </MainFrame>

            <ImageBanner image={vaccineSecImage} />

            <MainFrame>
                <SpacingFrame spacing={40}>
                    <TitleSubtitle title={ section4["title"][lang] } />
                    <ColAutoFrame>
                        { advantages }
                    </ColAutoFrame>
                </SpacingFrame>
            </MainFrame>

            <ExploreOtherServices location="vaccine-design" />
        </>
    )
};

export function PersonalizedMedicine() {
    const { lang } = useLang();

    const data = typedUnitContent["Personalized Medicine"];
    const section1 = data[1];
    useDocumentTitle(
        drugomicsChildTitle(
            drugomicsServiceTitle("personalized-medicine", lang),
            lang
        )
    );
    const section2 = data[2];
    const section3 = data[3];
    const section4 = data[4];

    // section 3: steps
    let devSteps = Object.keys(section3["content"]).map((i) => {
        let content = section3["content"][i];
        return (
            <StepsCard data={content} />
        )
    });

    // section 4: advantages
    let advantages = Object.keys(section4["content"]).map((i) => {
        let content = section4["content"][i];
        return (
            <LeftBorderCard data={content} />
        )
    });

    return (
        <>
            <BannerSection image={medicineBanner} title={ section1["title"][lang] } subtitle={ section1["caption"][lang] } textPosition="Top" />

            <NavTree />

            <MainIdeaSection text={ section2["text"][lang] } />

            <MainFrame>
                <SpacingFrame spacing={40}>
                    <TitleSubtitle title={ section3["title"][lang] } />
                    <p>{ section3["subtitle"][lang] }</p>
                    <SlideInAnim direction="bottom">
                        <img className="p-6" src={require("../../image/drugomics/" + section3["image"])} />
                    </SlideInAnim>
                    <ColAutoFrame>
                        { devSteps }
                    </ColAutoFrame>
                </SpacingFrame>
            </MainFrame>

            <ImageBanner image={medicineSecImage} />

            <MainFrame>
                <SpacingFrame spacing={40}>
                    <TitleSubtitle title={ section4["title"][lang] } />
                    <p>{ section4["subtitle"][lang] }</p>
                    <ColAutoFrame>
                        { advantages }
                    </ColAutoFrame>
                </SpacingFrame>
            </MainFrame>

            <ExploreOtherServices location="personalized-medicine" />
        </>
    )
};


////////////////////
// DRUG PIPELINE //
///////////////////
export function DrugomicsPipeline() {
    const { lang } = useLang();

    const data = typedUnitContent["Pipeline"];
    const section1 = data[1];
    useDocumentTitle(
        drugomicsChildTitle(drugomicsLocalizedTitle(section1["title"], lang), lang)
    );
    const section2 = data[2];
    const section3 = data[3];

    // section 4: advantages
    let process = Object.keys(section3["content"]).map((i) => {
        let content = section3["content"][i];
        return (
            <LeftBorderCard data={content} isBulletList />
        )
    });

    return (
        <>
            <BannerSection image={pipelineBanner} title={ section1["title"][lang] } subtitle={ section1["caption"][lang] } textPosition="Top" />

            <NavTree />

            <MainIdeaSection text={ section2["text"][lang] } />

            <MainFrame>
                <SpacingFrame spacing={40}>
                    <TitleSubtitle title={ section3["title"][lang] } />
                    <p>{ section3["subtitle"][lang] }</p>
                    <div className="lg:grid lg:grid-cols-3 lg:gap-y-10 gap-6 sm:flex sm:flex-col">
                        { process }
                    </div>
                </SpacingFrame>
            </MainFrame>

            <MainFrame>
                <DrugPipeline showAll />
            </MainFrame>
        </>
    )
};


export function DrugPipelineContent() {
    const { lang } = useLang();

    //const data = typedUnitContent["Drug Design"]; 
    const data = typePipelineContent["osteoarthritis"];
    useDocumentTitle(
        drugomicsChildTitle(drugomicsLocalizedTitle(data["title"], lang), lang)
    );    const section1 = data[1];
    const section2 = data[2];
    const section3 = data[3];
    const section4 = data[4];
    const section5 = data[5];
    const section6 = data[6];
    const section7 = data[7];
    const section8 = data[8];
    const section9 = data[9];
    const section10 = data[10];

    let osteoarthritis_key_risk_factors = Object.keys(section3["content"]).map((i) => {
        let data = section3["content"][i];
        let image = require("../../image/icons/" + data["icon"]);
        return (
            <div className="w-full h-fit flex flex-col items-center justify-center gap-8">
                <div className="relative w-20 h-20 rounded-full bg-teal-500">
                    <div className="absolute w-20 h-20 flex items-center justify-center">
                        <img className="w-10 h-10" src={ image } />
                    </div>
                </div>
                <SpacingFrame spacing={12}>
                    <p className="text-md font-semibold text-grey-800">{ data["title"][lang] }</p>
                    <p className="text-sm text-grey-400">{ data["subtitle"][lang] }</p>
                </SpacingFrame>
            </div>
        )
    });


    // section 6
    let devStepsSection6 = Object.keys(section6["content"]).map((i) => {
        let content = section6["content"][i];
        return (
            <StepsCardWithList data={content} imagePath="image/drugomics/" />
        )
    });

    // section 7
    let devStepsSection7 = Object.keys(section7["content"]).map((i) => {
        let content = section7["content"][i];
        return (
            <StepsCardWithList data={content} imagePath="image/drugomics/" />
        )
    });
    
    return (

        <>
      
            <BannerSection image={pipelineBanner} title={ data["title"][lang] } subtitle={ data["subtitle"][lang] } textPosition="Top" />
            
            <NavTree />

            <MainIdeaSection text={ section1["text"][lang] } />

            <MainFrame>
                <StatsSection title={ section2["title"][lang] } subtitle={ section2["subtitle"][lang] } data={ section2["content"] } />
            </MainFrame>

            {/* <MainFrame style={{ backgroundColor: "rgba(248, 249, 250, 1)", overflow: "hidden" }}>
                <SpacingFrame>
                    <TitleSubtitle title={ section3["title"][lang] } subtitle={ section3["subtitle"][lang] } />
                    <SlideInAnim direction="bottom">
                        <Col4ContentFrame>
                           {osteoarthritis_key_risk_factors}
                        </Col4ContentFrame>
                    </SlideInAnim>
                </SpacingFrame>
            </MainFrame> */}

            <DisplayInfo2Cols contentData={section4["content"]} imagePath={imagePath} />

            <MainIdeaSection text={ section5["text"][lang] } />

            <MainFrame>
                <SpacingFrame spacing={40}>
                    <TitleSubtitle title={ section6["title"][lang]} left />
                    <p>{ section6["subtitle"][lang] }</p>
                    {/* <SlideInAnim direction="bottom">
                        <img className="p-6" src={require("../../image/drugomics/" + section6["image"])} />
                    </SlideInAnim> */}
                    <ColAutoFrame>
                        { devStepsSection6 }
                    </ColAutoFrame>
                </SpacingFrame>
            </MainFrame>

            <MainFrame>
                <SpacingFrame spacing={40}>
                    <TitleSubtitle title={ section7["title"][lang]} left />
                    <p>{ section7["subtitle"][lang] }</p>
                    {/* <SlideInAnim direction="bottom">
                        <img className="p-6" src={require("../../image/drugomics/" + section7["image"])} />
                    </SlideInAnim> */}
                    <ColAutoFrame>
                        { devStepsSection7 }
                    </ColAutoFrame>
                </SpacingFrame>
            </MainFrame>

            <div style={{ backgroundColor: "rgba(248, 249, 250, 1)"}}>
                <DisplayInfo2Cols contentData={section8["content"]} imagePath={imagePath} />
            </div>

            <MainFrame>
                <TitleSubtitle title={ section9["title"][lang] } />
                <SpacingFrame>
                    <TextBody text={ section9["content"]["text"][lang] } />
                    <p className="text-lg text-left font-semibold text-grey-800">{ section9["content"]["subtitle"][lang] }</p>
                    <LeftBorderCard data={ section9["content"][0] } isBulletList />
                </SpacingFrame>
            </MainFrame>

            <DisplayInfo2Cols contentData={section10["content"]} imagePath={imagePath} />
        
        </>

    )
};


export function DrugPipelineContentFibrosis() {
    const { lang } = useLang();

    //const data = typedUnitContent["Drug Design"]; 
    const data = typePipelineContent["fibrotic-disorders"];
    useDocumentTitle(
        drugomicsChildTitle(drugomicsLocalizedTitle(data["title"], lang), lang)
    );    const section1 = data[1];
    
    return (

        <>
        
            <BannerSection image={pipelineBanner} title={ data["title"][lang] } subtitle={ data["subtitle"][lang] } textPosition="Top" />

            <NavTree />

            <DisplayInfo2Cols contentData={section1["content"]} imagePath={imagePath} />
              
        </>

    )
};